import { StoreState } from '../store-interfaces';

export const selectAudienceVariables = (state: StoreState) =>
  state.audiences.variables || [];
